import React from "react";
import { LegalPage, LegalSection } from "./LegalPage";

export const Aml = () => (
  <LegalPage
    eyebrow="Legal · Financial Crime"
    title="AML & Financial Crime Policy"
    lastUpdated="February 2026"
  >
    <LegalSection heading="Our position">
      <p>
        FIND LET takes reasonable and proportionate measures to prevent its services from being used for money laundering, fraud, or other unlawful activity. We do not tolerate the use of our platform or concierge service for any such purpose.
      </p>
    </LegalSection>

    <LegalSection heading="Information we may request">
      <p>
        Where it is legally required or reasonably necessary — for example, in connection with a qualifying lettings transaction or an unusually high-value arrangement — FIND LET may request additional information from renters, landlords, property partners or other users. This may include:
      </p>
      <ul className="list-disc pl-5 space-y-1.5">
        <li>Proof of identity.</li>
        <li>Proof of address.</li>
        <li>Ownership or authority-to-let information for a property.</li>
        <li>Source-of-funds information where relevant.</li>
        <li>Other supporting information proportionate to the transaction.</li>
      </ul>
      <p>
        We may decline to proceed with an introduction, listing or service where the requested information is not provided, cannot be verified, or where we have concerns about a transaction.
      </p>
    </LegalSection>

    <LegalSection heading="Applicable legal obligations">
      <p>
        UK anti-money-laundering rules for letting agency businesses can apply to qualifying lettings, depending on factors such as monthly rent and the length of the tenancy. Where any such obligations apply to a specific transaction facilitated through FIND LET, we will comply with them.
      </p>
      <p>
        This policy is proportionate to the current stage and nature of the FIND LET service, and does not purport to describe every applicable rule.
      </p>
    </LegalSection>

    <LegalSection heading="Reporting concerns">
      <p>
        Where required by law, FIND LET will report suspicious activity to the relevant UK authorities. In some circumstances, we may be legally prohibited from telling you that a report has been made.
      </p>
      <p>
        If you have concerns about suspected financial crime relating to a listing, enquiry or interaction on FIND LET, please contact the concierge desk at{" "}
        <a href="mailto:concierge@findlet.uk" className="editorial-link">concierge@findlet.uk</a>.
      </p>
    </LegalSection>

    <LegalSection heading="Not legal or financial advice">
      <p>
        This policy sets out how FIND LET approaches financial crime prevention. It is not legal or financial advice. If you need advice about your own anti-money-laundering obligations, please speak to a qualified professional.
      </p>
    </LegalSection>

    <LegalSection heading="Changes to this policy">
      <p>
        We may update this policy from time to time. The "Last updated" date at the top of the page reflects the most recent version.
      </p>
      <p className="text-xs italic text-[#7096D1]">
        {/* Post-incorporation TODO: once FIND LET is incorporated and, where applicable, HMRC AML-supervised, insert the registered operator name and any supervisory registration details here. Do not add fabricated registration information. */}
        FIND LET is currently pre-launch. Registered operator and, where applicable, supervisory details will be published here once available.
      </p>
    </LegalSection>
  </LegalPage>
);
